import { useNavigate } from "react-router-dom";
import { LuChevronLeft } from "react-icons/lu";

// Bouton retour global (app native). Positionné en haut à gauche, sous le header.
const MobileBackButton = ({ className = "", onClick, style }) => {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      aria-label="Retour"
      onClick={
        onClick ||
        (() => {
          if (window.history.length > 1) navigate(-1);
          else navigate("/app-home");
        })
      }
      style={style}
      className={`inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/95 backdrop-blur shadow-md border border-gray-200 text-[#343F4B] active:scale-95 transition ${className}`}
    >
      <LuChevronLeft size={22} />
    </button>
  );
};

export default MobileBackButton;
